/**
 * White-label branding configuration.
 *
 * Change these values to rebrand the entire platform.
 * When companyName !== "ubloquity", a "Powered by ubloquity" badge
 * appears in the sidebar footer and public passport footer.
 */

export interface BrandConfig {
  platformName: string
  companyName: string
  logoUrl: string
  primaryColour: string
  accentColour: string
  darkColour: string
  contactUrl?: string
  /** Automatically set: true when companyName !== "ubloquity" */
  isWhiteLabel: boolean
}

const companyName = 'ubloquity'

export const branding: BrandConfig = {
  platformName: 'ubloquity DPP Platform',
  companyName,
  logoUrl: 'logo.svg',
  primaryColour: '#013C7A',
  accentColour: '#E6204D',
  darkColour: '#002045',
  contactUrl: 'https://ubloquity.io',
  isWhiteLabel: companyName !== 'ubloquity',
}
